/* 市场营销 数据字典 */
// 线索状态
export const clueStatus = [
  {
    value: undefined,
    label: '全部'
  },
  {
    value: 0,
    label: '未投放'
  },
  {
    value: 1,
    label: '已投放'
  }
]
export const flagEnum = [
  { value: 1, label: '是' },
  { value: 0, label: '否' }
]
export const cluePushResultEnum = [
  {
    value: -1,
    label: '错误'
  },
  {
    value: 0,
    label: '失败'
  },
  {
    value: 1,
    label: '成功'
  }
]
// 线索类型
export const clueType = [
  {
    value: 0,
    label: '新线索'
  },
  {
    value: 1,
    label: '未来线索'
  },
  {
    value: 2,
    label: '有效线索'
  },
  {
    value: 3,
    label: '无效线索'
  }
]
// 线索接收类型
export const acceptClueSystem = [
  {
    value: 'cos_lbu',
    label: '云途'
  },
  {
    value: 'cos_fbu',
    label: '谷仓'
  }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const customerStageEnum = [
  { value: 1, label: '销售线索' },
  { value: 2, label: '潜在客户' },
  { value: 3, label: '签约客户' },
  { value: 4, label: '成交客户' }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const lbuCustomerStageEnum = [
  { value: 1, label: '销售线索' },
  { value: 2, label: '潜在客户' },
  { value: 4, label: '成交客户' }
]
export const customerAllStatusEnum = [
  { label: '线索公海池', value: 0 },
  { label: '待领取', value: 1 },
  { label: '待跟进', value: 2 },
  { label: '跟进中', value: 3 },
  { label: '无效线索', value: 5 },
  { label: '已转换', value: 8 },
  { label: '谈判', value: 10 },
  { label: '已注册', value: 11 },
  { label: '搁置', value: 12 },
  { label: '无合作可能', value: 13 },
  { label: '归档', value: 14 },
  { label: '对接中', value: 20 },
  { label: '暂停合作', value: 21 },
  { label: '终止合作', value: 22 },
  { label: '已签约', value: 30 },
  { label: '磨合', value: 31 },
  { label: '上涨', value: 32 },
  { label: '下降', value: 33 },
  { label: '稳定', value: 34 },
  { label: '保持', value: 35 },
  { label: '流失', value: 36 }
]
export const fbuCustomerAllStatusEnum = [
  { label: '线索公海池', value: 0 },
  { label: '待领取', value: 1 },
  { label: '待跟进', value: 2 },
  { label: '跟进中', value: 3 },
  { label: '已转换', value: 8 },
  { label: '谈判', value: 10 },
  { label: '搁置', value: 12 },
  { label: '归档', value: 14 },
  { label: '对接中', value: 20 },
  { label: '暂停合作', value: 21 },
  { label: '终止合作', value: 22 },
  { label: '磨合', value: 31 },
  { label: '上涨', value: 32 },
  { label: '下降', value: 33 },
  { label: '保持', value: 35 },
  { label: '流失', value: 36 }
]
export const lbuCustomerAllStatusEnum = [
  { label: '线索公海池', value: 0 },
  { label: '待领取', value: 1 },
  { label: '待跟进', value: 2 },
  { label: '跟进中', value: 3 },
  { label: '无效线索', value: 5 },
  { label: '已转换', value: 8 },
  { label: '谈判', value: 10 },
  { label: '已注册', value: 11 },
  { label: '无合作可能', value: 13 },
  { label: '已签约', value: 30 },
  { label: '上涨', value: 32 },
  { label: '下降', value: 33 },
  { label: '稳定', value: 34 },
  { label: '流失', value: 36 }
]
// 渠道来源
export const sourceTypeOption = [
  {
    value: '1',
    label: '渠道对接'
  },
  {
    value: '2',
    label: '线上活动'
  },
  {
    value: '3',
    label: '线下展会'
  }
]
// 联系方式
export const linkMethods = [
  {
    value: 1,
    label: '手机号'
  },
  {
    value: 3,
    label: '邮箱'
  },
  {
    value: 5,
    label: 'qq'
  },
  {
    value: 4,
    label: '微信号'
  },
  {
    value: 2,
    label: '固定电话'
  }
]
// 性别
export const genderEnum = [
  {
    value: 1,
    label: '男',
    lang: 'mobile.zziz9a'
  },
  {
    value: 2,
    label: '女',
    lang: 'mobile.1an818'
  }
]
// 客户类型
export const customerTypeEnum = [
  {
    value: 1,
    label: '个人',
    lang: 'enum.customerType1'
  },
  {
    value: 2,
    label: '企业',
    lang: 'enum.customerType2'
  }
]
/* 联系人角色类型 */
export const linkRoleTypeEnum = [
  {
    value: 1,
    label: '采购者',
    lang: 'enum.linkRoleType1'
  },
  {
    value: 2,
    label: '决策者',
    lang: 'enum.linkRoleType2'
  },
  {
    value: 3,
    label: '使用者',
    lang: 'enum.linkRoleType3'
  }
]
/* 评级 */
export const starGrade = [
  { label: '一星', value: 1 },
  { label: '二星', value: 2 },
  { label: '三星', value: 3 },
  { label: '四星', value: 4 },
  { label: '五星', value: 5 }
]
/* 评级 */
export const joinFlag = [
  { label: '参加', value: 1 },
  { label: '不参加', value: 2 }
]
export default {
  clueStatus,
  clueType,
  acceptClueSystem,
  sourceTypeOption,
  linkMethods,
  genderEnum,
  customerTypeEnum,
  linkRoleTypeEnum,
  starGrade,
  joinFlag,
  cluePushResultEnum,
  customerStageEnum,
  customerAllStatusEnum,
  flagEnum,
  lbuCustomerStageEnum,
  lbuCustomerAllStatusEnum,
  fbuCustomerAllStatusEnum
}
